<template>
  <v-hover v-slot="{ hover }">
    <v-card
      v-if="!loadingContent"
      elevation="0"
      class="py-2 px-5 card"
      :class="{'on-hover': hover}"
      style="position: relative"
      @click="dialog = true"
    >
      <FlexColumn :space="2">
        <div class="request-send-info">
          <Label bold text="送付担当者" />
          <FlexRow align="center" class="mt-0">
            <v-avatar size="34">
              <v-img v-if="requestor.imageUrl" :src="requestor.imageUrl" />
              <v-icon v-else size="40" style="color: #bbb">
                mdi-account-circle
              </v-icon>
            </v-avatar>
            <Label :text="requestor.lastName + ' ' + requestor.firstName" />
          </FlexRow>
        </div>
        
        <div class="request-send-info">
          <Label bold text="テンプレート" />
          <Label :text="templateName || '-'"/>
        </div>
      </FlexColumn>
      
      <v-icon
        dense
        style="position: absolute; top: 10px; right: 10px; font-size: 22px; color: #999"
      >
        mdi-square-edit-outline
      </v-icon>

      <JobSelectDialog
          :requestor="requestor"
          :open="dialog"
          @close="dialog = false"
          @select="handleSelect"
      />
    </v-card>
  </v-hover>
</template>

<script>
import Label from "@/components/atoms/Label";
import FlexColumn from "@/components/atoms/FlexColumn";
import JobSelectDialog from "@/components/organisms/JobSelectDialog";
import {mapGetters} from "vuex";
import ApiMixin from "@/ApiMixin";
import FlexRow from "../atoms/FlexRow";

export default {
  mixins: [ApiMixin],
  name: "RequestTemplateCard",
  components: {FlexRow, JobSelectDialog, FlexColumn, Label},
  props: {
    requestor: {
      type: Object,
      default: () => ({
      
      })
    }
  },
  data() {
    return {
      jobId: undefined,
      dialog: false,
      templateId: undefined,
      motivationIds: []
    }
  },
  computed: {
    ...mapGetters("message", ["scoutTemplates"]),
    ...mapGetters("system", ["consts"]),
    templateName() {
      const template = this.scoutTemplates.find(item => item.id === this.templateId)
      return template ? template.name : "未指定"
    },
    motivations() {
      if (this.consts.scoutMotivation) {
        return this.consts.scoutMotivation.filter(item => this.motivationIds.includes(item.value)).map(item => item.label)
      }
      return []
    },
    loadingContent() {
      return Object.keys(this.requestor).length === 0
    }
  },
  methods: {
    loadStorage() {
      this.templateId = this.$cookies.get('nishika.chat-requests-scout-message-template')
      const ids = this.$cookies.get('nishika.chat-requests-scout-motivations')
      this.motivationIds = ids ? ids.split(',').map(item => Number(item)) : []
    },
    handleSelect(requestorId) {
      this.dialog = false
      this.loadStorage()
      this.$emit("change:requestor", requestorId)
    }
  },
  watch: {
    "$route": {
      handler: function () {
        this.loadStorage()
      },
      immediate: true
    },
  }
}
</script>

<style scoped>
.card {
  background-color: #00000011;
}
.on-hover {
  background-color: #00000018;
}
.request-send-info {
  display: grid;
  align-items: center;
  grid-template-columns: 160px 1fr;
  min-height: 34px;
}
</style>